import React, { useEffect } from 'react';
import axios from 'axios';
import useStorage from '../../../utils/hooks/useStorage';
import { useRouter } from 'next/router';

import SiteHeader from '../../../components/shared/SiteHeader';
import EventDetail from '../../../components/local/events/EventDetail';

import { getStrapiURL } from '../../../lib/api';
const apiBaseUrl = getStrapiURL();

const EventDetails = ({ eventData, error, eventSlug }) => {
  const { getItem, setItem, removeItem } = useStorage();
  const currentUtm = getItem('utm') && JSON.parse(getItem('utm'));
  const { query } = useRouter();
  if (query?.utm_source) {
    if (currentUtm?.utm_source !== query?.utm_source) {
      setItem('utm', JSON.stringify(query));
    }
  } else {
    removeItem('utm');
  }
  if (error)
    return <div className="my-40 mx-20 flex items-center justify-center">404 | Page not found</div>;
  const URL = `/events/${eventData.slug}`;

  return (
    <>
      <SiteHeader
        title={eventData?.title}
        desc={eventData?.title}
        image={eventData?.eventImage?.data?.attributes?.url}
        url={URL}
      />

      <div className="container-default-1209px" id="modal">
        <EventDetail eventData={eventData} eventSlug={eventSlug} />
      </div>
    </>
  );
};

export default EventDetails;

export async function getServerSideProps({ query, res }) {
  const { eventSlug } = query;
  try {
    const { data } = await axios.get(
      `${apiBaseUrl}/api/events?populate=instructor.DisplayPicture&populate=instructor.CompanyImage&populate=eventImage&populate=eventAgenda&populate=whoShouldaAttend&populate=perks.features&populate=perks.images&filters[$and][0][slug][$eq]=${eventSlug}`
    );
    const eventData = data.data[0].attributes;
    res.setHeader('Cache-Control', 'public, s-maxage=1800, stale-while-revalidate');
    return { props: { eventData: eventData || {}, eventSlug } };
  } catch (error) {
    return { props: { error } };
  }
}
